import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import NumericInput from '@/components/v2/NumericInput.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { requiredProperty } from '@/helpers/mixins/LocalizationHelper';
import { Getter } from 'vuex-class';
import BaseDateTimeField from '@/components/datetime_field/Index.vue';
import DateMixin from '@/helpers/mixins/DateMixin';
import WhiteSpaceCheckerMixin from '@/helpers/vue_mixins/WhiteSpaceCheckerMixin';
import BaseDatePicker from '@/components/datepicker/Index.vue';
import BaseTimePicker from '@/components/timepicker/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import VEditorField from '@/components/v2/VEditorField.vue';
import moment from 'moment';
import WindowSizeListener from '@/helpers/vue_mixins/v3/WindowSizeListenerMixin';
import StoreAnnouncementBannerPreview from '@/components/v3/StoreAnnouncementBannerPreview.vue';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import RadioBoxGroup from '@/views/v3/RadioBoxGroup.vue';
import BaseImagePlaceholder from '@/components/v2/BaseImagePlacelholder';
import Uploader from '@/components/v2/Uploader';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
let StoreAnnouncementBannerForm = class StoreAnnouncementBannerForm extends mixins(mixins(FormMixin, DateMixin, ViewportSizeMixin, WhiteSpaceCheckerMixin, WindowSizeListener), FormValidationsMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.hasSubmitted = false;
        this.showBannerPreview = false;
        this.showBannerForm = true;
        this.newData = false;
        this.selectedOption = 1;
        this.options = [
            { value: 'Image', subText: 'Upload banner image', index: 1 },
            { value: 'Text', subText: 'Write up announcement', index: 2 },
        ];
        this.fileExceeded = false;
        this.hasRejectedFiles = false;
        this.persistentFiles = [];
        this.backgroundColor = '';
        this.form = {
            announcementText: null,
            bgColor: '#007bff',
            startAt: null,
            endAt: null,
            startAtTime: null,
            endAtTime: null,
            active: true,
            images: [],
        };
        this.durationTrigger = false;
        this.openStartDateModal = false;
        this.openEndDateModal = false;
        this.openStartTimeModal = false;
        this.openEndTimeModal = false;
    }
    get checkImageUnshow() {
        const activeImages = this.form.images.filter((image) => image.state !== 'deleted').length;
        return activeImages >= 1;
    }
    handleOptionChange(option) {
        if (option === 2 && this.form.images.length > 0) {
            this.persistentFiles = [...this.form.images];
        }
        this.selectedOption = option;
        if (option === 1 && this.persistentFiles.length > 0 && this.title === 'Edit Announcements') {
            // Restore images when switching back
            this.form.images = this.persistentFiles.map((image) => ({
                ...image,
                state: image.state === 'deleted' ? 'idle' : image.state,
            }));
        }
    }
    fileExceed() {
        this.fileExceeded = true;
        this.checkRejectedFiles();
        this.errorNotification('Exceeded total Number of files');
    }
    checkRejectedFiles() {
        const self = this;
        this.hasRejectedFiles = !!self.$refs.uploader.getRejectedFiles().length;
    }
    onResize() {
        if (this.window.width < 1025) {
            this.openBannerForm();
        }
        else {
            this.showBannerForm = true;
            this.showBannerPreview = true;
        }
    }
    openBannerForm() {
        if (this.window.width < 1025) {
            this.showBannerForm = true;
            this.showBannerPreview = false;
        }
    }
    openBannerPreview() {
        if (this.window.width < 1025) {
            this.showBannerForm = false;
            this.showBannerPreview = true;
        }
    }
    goBack() {
        this.openBannerForm();
    }
    get predefinedColors() {
        return ['#007bff', '#0cd4f4', '#ecd46c', '#e4a4ff', '#ffffff'];
    }
    updateBackgroundColor(color) {
        this.backgroundColor = color;
    }
    get title() {
        return this.update ? 'Edit Announcements' : 'Create Announcements';
    }
    goBackMarketingTools() {
        this.$router.push({
            name: 'store-announcement-manager',
        });
    }
    get announcementTextErrors() {
        const errors = [];
        // if (!this.$v.form.announcementText!.$dirty) {
        //   return errors;
        // }
        const strippedText = this.stripHtmlTags(this.$v.form.announcementText?.$model || '');
        if (strippedText.trim().length === 0) {
            errors.push('Text is required');
        }
        if (strippedText.length > 150) {
            errors.push('Text must be less than 150 characters');
        }
        return errors;
    }
    get action() {
        return this.update ? 'Edit' : 'Create';
    }
    stripHtmlTags(input) {
        return input.replace(/<[^>]*>/g, '').trim();
    }
    get htmlError() {
        if (this.hasSubmitted) {
            const strippedAnnouncementText = this.stripHtmlTags(this.form.announcementText || '');
            if (strippedAnnouncementText.length === 0) {
                return ['Text is required'];
            }
        }
        return [];
    }
    get endAtErrors() {
        const errors = [];
        if (!this.$v.form.endAt.$dirty) {
            return errors;
        }
        if (!this.$v.form.endAt.required) {
            const msg = requiredProperty('End Date');
            errors.push(msg);
        }
        if (!this.$v.form.endAt.mustBeAfterStartDate) {
            errors.push('End Date should be after Start Date');
        }
        return errors;
    }
    get endTimeErrors() {
        const errors = [];
        if (!this.$v.form.endAtTime.$dirty) {
            return errors;
        }
        if (!this.$v.form.endAtTime.required) {
            const msg = requiredProperty('End Time');
            errors.push(msg);
        }
        return errors;
    }
    get startTimeErrors() {
        const errors = [];
        if (!this.$v.form.startAtTime.$dirty) {
            return errors;
        }
        if (!this.$v.form.startAtTime.required) {
            const msg = requiredProperty('Start Time');
            errors.push(msg);
        }
        return errors;
    }
    get startAtErrors() {
        const errors = [];
        if (!this.$v.form.startAt.$dirty) {
            return errors;
        }
        if (!this.$v.form.startAt.required) {
            const msg = requiredProperty('Start Date');
            errors.push(msg);
        }
        return errors;
    }
    get startDateError() {
        if (this.durationTrigger && !this.form.startAt) {
            if (this.form.startAtTime || this.form.endAt || this.form.endAtTime) {
                return ['Start Date is required'];
            }
        }
        return [];
    }
    get endDateError() {
        if (this.durationTrigger && !this.form.endAt) {
            if (this.form.startAtTime || this.form.startAt || this.form.endAtTime) {
                return ['End Date is required'];
            }
        }
        return [];
    }
    get startAtTimeError() {
        if (this.durationTrigger && !this.form.startAtTime) {
            if (this.form.endAtTime || this.form.startAt || this.form.endAt) {
                return ['Start Time is required'];
            }
        }
        return [];
    }
    get endAtTimeError() {
        if (this.durationTrigger && !this.form.endAtTime) {
            if (this.form.startAtTime || this.form.startAt || this.form.endAt) {
                return ['End Time is required'];
            }
        }
        return [];
    }
    onSubmit() {
        this.hasSubmitted = true;
        this.$v.$touch();
        const strippedAnnouncementText = this.stripHtmlTags(this.form.announcementText || '').trim();
        if (this.$v.$invalid ||
            (this.selectedOption === 2 &&
                (strippedAnnouncementText.length === 0 || strippedAnnouncementText.length > 150))) {
            return;
        }
        if (this.selectedOption === 1 && this.form.images.length === 0) {
            this.errorNotification("Image upload is required.");
            return;
        }
        if (this.selectedOption === 1) {
            this.form.announcementText = null;
        }
        // if (this.selectedOption === 1) {
        //   this.form.announcementText = null;
        // } else if (this.selectedOption === 2) {
        //   this.form.images = null;
        // }
        this.$emit('submit', this.form);
    }
    mounted() {
        if (this.formData) {
            this.form = { ...this.formData };
            this.selectedOption = this.form.images.length ? 1 : 2;
        }
    }
    get minEndAtDate() {
        const startDate = new Date(this.form.startAt);
        const minDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 2);
        return moment(minDate).format('YYYY-MM-DD');
    }
    get startAtFilled() {
        this.durationTrigger = false;
        return !!this.$v.form?.startAt?.$model;
    }
    onStartDateChange() {
        this.$nextTick(() => {
            this.startAtFilled;
        });
    }
    get endAtFilled() {
        return !!this.$v.form?.endAt?.$model;
    }
    onEndDateChange() {
        this.$nextTick(() => {
            this.endAtFilled;
        });
    }
    clearStartAt() {
        if (this.$v?.form?.startAt) {
            this.$v.form.startAt.$model = null;
        }
    }
    clearStartAtTime() {
        if (this.$v?.form?.startAtTime) {
            this.$v.form.startAtTime.$model = null;
        }
    }
    clearEndAt() {
        if (this.$v?.form?.endAt) {
            this.$v.form.endAt.$model = null;
        }
    }
    clearEndAtTime() {
        if (this.$v?.form?.endAtTime) {
            this.$v.form.endAtTime.$model = null;
        }
    }
};
__decorate([
    Getter('requestOnFlight')
], StoreAnnouncementBannerForm.prototype, "mutationRequestOnFlight", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], StoreAnnouncementBannerForm.prototype, "update", void 0);
__decorate([
    Prop({ type: Object, default: null })
], StoreAnnouncementBannerForm.prototype, "formData", void 0);
__decorate([
    Watch('window.width')
], StoreAnnouncementBannerForm.prototype, "onResize", null);
StoreAnnouncementBannerForm = __decorate([
    Component({
        components: {
            ActionButton,
            FormHeader,
            NumericInput,
            BaseTextField,
            BaseDateTimeField,
            BaseDatePicker,
            BaseTimePicker,
            VEditorField,
            StoreAnnouncementBannerPreview,
            RadioBoxGroup,
            BaseImagePlaceholder,
            Uploader,
        },
        validations: {
            form: {
                announcementText: {},
                startAt: {},
                endAt: {
                    required() {
                        const { startAt, endAt } = this.form;
                        return !startAt || !!endAt;
                    },
                    mustBeAfterStartDate() {
                        const startDate = this.form.startAt;
                        const endDate = this.form.endAt;
                        if (!startDate) {
                            return true;
                        }
                        const parsedStartDate = new Date(startDate);
                        const parsedEndDate = new Date(endDate);
                        return parsedEndDate > parsedStartDate;
                    },
                },
                startAtTime: {
                    required() {
                        const { startAt, startAtTime } = this.form;
                        return !startAt || !!startAtTime;
                    },
                },
                endAtTime: {
                    required() {
                        const { startAt, endAtTime } = this.form;
                        return !startAt || !!endAtTime;
                    },
                },
            },
        },
    })
], StoreAnnouncementBannerForm);
export default StoreAnnouncementBannerForm;
